// extracted by mini-css-extract-plugin
module.exports = {"loading-screen-container":"LoadingScreen_loading-screen-container__xjoXn"};